// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../images/pinkChekck.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../images/MiffyUnclicked.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../images/MiffyClicked.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html, body {
  min-height: 100%;
  background-color: #b7d395;
  font-family: Inter, sans-serif;
  font-feature-settings: "liga" 1, "calt" 1; /* fix for Chrome */
}

.pageLayout {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
}
.pageLayout .container {
  height: 90%;
  width: 80%;
  left: 50%;
  position: absolute;
  top: 50%;
  z-index: 10;
}
.pageLayout .container .pageBody {
  background: #b7d395;
  height: 100%;
  left: -50%;
  position: absolute;
  top: -50%;
  width: 100%;
  border: solid 1px #ffffff;
  overflow-x: hidden;
  overflow-y: auto;
}
.pageLayout .rowTitle {
  border-left: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.pageLayout .colTitle {
  border-bottom: 1px solid #ffffff;
  padding-top: 20px;
  padding-bottom: 20px;
  text-align: center;
  text-decoration: none;
}
.pageLayout .colTitle .navTitle {
  color: black;
  background-color: #ffffff;
  text-decoration: none;
  font-size: medium;
}
@media (max-width: 576px) {
  .pageLayout .colTitle .navTitle {
    /* CSS that should be displayed if width is equal to or less than 800px goes here */
    font-size: medium;
  }
}
.pageLayout .colTitle .subTitle {
  color: black;
  text-decoration: none;
  font-size: medium;
}
@media (max-width: 576px) {
  .pageLayout .colTitle .subTitle {
    /* CSS that should be displayed if width is equal to or less than 800px goes here */
    font-size: medium;
  }
}
.pageLayout .colTitle .title {
  color: black;
  background-color: #ffffff;
  text-decoration: none;
}
.pageLayout .colTitle div {
  color: #ffffff;
}
.pageLayout .productPageContainer {
  position: inherit;
}
.pageLayout .productPageContainer .col {
  border-bottom: 1px solid #ffffff;
  border-left: 1px solid #ffffff;
  text-align: center;
}
.pageLayout .productPageContainer .col div {
  color: #ffffff;
}
.pageLayout .productPageContainer .row > * {
  padding-right: 0 !important;
  padding-left: 0 !important;
}
.pageLayout .productPageContainer .imageWrapper {
  width: 100%;
  height: 0;
  margin: auto;
  padding-bottom: 100%;
  overflow: hidden;
  position: relative;
  z-index: 90;
}
.pageLayout .productPageContainer .imageWrapper .mainImage {
  width: 100%;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  z-index: 90;
  transition: opacity 0.5s;
}
.pageLayout .productPageContainer .imageWrapper:hover .mainImage, .pageLayout .productPageContainer .imageWrapper:active .mainImage, .pageLayout .productPageContainer .imageWrapper:focus .mainImage {
  opacity: 0;
}
.pageLayout .productPageContainer .imageWrapper .hoverImage {
  height: 100%;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
}
.pageLayout .productPageContainer .NailCommission-imageWrapper {
  width: 100%;
  height: 0;
  margin: auto;
  padding-bottom: 100%;
  overflow: hidden;
  position: relative;
  z-index: 90;
  display: flex;
  justify-content: center;
  align-content: center;
}
.pageLayout .productPageContainer .NailCommission-imageWrapper .NailCommission-mainImage {
  width: 80%;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  z-index: 90;
  transition: background-color 0.5s;
}
.pageLayout .productPageContainer .NailCommission-imageWrapper .NailCommission-Image {
  padding: 10px;
}
.pageLayout .productPageContainer .NailCommission-imageWrapper .NailCommissionPage-col {
  padding: 10px;
}
.pageLayout .productPageContainer .NailCommission-imageWrapper .NailCommissionPage-row {
  border: white;
}
.pageLayout .productPageContainer .NailCommission-imageWrapper:hover .NailCommission-mainImage, .pageLayout .productPageContainer .NailCommission-imageWrapper:active .NailCommission-mainImage, .pageLayout .productPageContainer .NailCommission-imageWrapper:focus .NailCommission-mainImage {
  opacity: 0;
}
.pageLayout .productPageContainer .NailCommission-imageWrapper .NailCommission-hoverImage {
  height: 100%;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
}
.pageLayout .productPageContainer .NailCommission-tileTitleWrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
}
.pageLayout .productPageContainer .NailCommission-tileTitle {
  color: #ffffff;
  text-decoration: none;
  font-size: 20rem;
  position: absolute;
  transform: translateY(-45%);
  z-index: 100000;
  opacity: 50%;
}
@media (max-width: 992px) {
  .pageLayout .productPageContainer .NailCommission-tileTitle {
    /* CSS that should be displayed if width is equal to or less than 800px goes here */
    transform: translateY(-50%);
    font-size: 100px;
  }
}
.pageLayout .productPageContainer:hover .NailCommission-tileTitle, .pageLayout .productPageContainer:active .NailCommission-tileTitle, .pageLayout .productPageContainer:focus .NailCommission-tileTitle {
  color: #b7d395;
}
.pageLayout .productPageContainer .tileTitleWrapper {
  display: none;
}
.pageLayout .productPageContainer .tileTitle {
  display: none;
}
.pageLayout .productPageContainer:hover .tileTitle, .pageLayout .productPageContainer:active .tileTitle, .pageLayout .productPageContainer:focus .tileTitle {
  display: block;
  color: black;
  background-color: #ffffff;
  text-decoration: none;
  position: absolute;
  transform: translateY(-100%);
  left: 1%;
  bottom: 1%;
  z-index: 100000;
}
.pageLayout .NailCommissionPageContent {
  position: inherit;
}
.pageLayout .NailCommissionPageContent .col {
  border-bottom: 1px solid #ffffff;
  border-left: 1px solid #ffffff;
  text-align: center;
}
.pageLayout .NailCommissionPageContent .col div {
  color: #ffffff;
}
.pageLayout .NailCommissionPageContent .row > * {
  padding-right: 0 !important;
  padding-left: 0 !important;
}
.pageLayout .NailCommissionPageContent .NailCommissionPage-row {
  padding: 40px;
}
.pageLayout .NailCommissionPageContent .NailCommissionPage-ImageWrapper {
  display: flex;
  justify-content: center;
  align-content: center;
}
.pageLayout .NailCommissionPageContent .NailCommissionPage-Image {
  height: auto;
  width: 40px;
}
.pageLayout .NailCommissionPageContent .NailCommissionPage-TextWrapper {
  display: flex;
  justify-content: center;
  align-content: center;
}
.pageLayout .NailCommissionPageContent .NailCommissionPage-Text {
  color: black;
  background-color: #ffffff;
  text-decoration: none;
}
.pageLayout .homePageContent img {
  width: 100%;
}
.pageLayout .pageFooter {
  color: #ffffff;
  width: 100%;
  text-align: center;
  padding: 10px;
}
.pageLayout .pageFooter .pageFooterText {
  margin: 0 auto;
  vertical-align: middle;
}
.pageLayout .pageFooter .pageFooterText p {
  margin: 0px;
}
.pageLayout .pageFooter .pageFooterImage {
  display: inline-block;
  margin: 0 auto;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-size: contain;
  height: 50px;
  width: 50px;
}
.pageLayout .pageFooter:hover .pageFooterImage, .pageLayout .pageFooter:active .pageFooterImage, .pageLayout .pageFooter:focus .pageFooterImage {
  display: inline-block;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-repeat: no-repeat;
  background-size: contain;
  height: 50px;
  width: 50px;
}
.pageLayout .detailPageContent img {
  width: 100%;
}
.pageLayout .detailPageContent .email {
  height: 1.1rem;
  width: auto;
  vertical-align: bottom;
}
.pageLayout .aboutPageContent {
  /* Style all font awesome icons */
  /* Add a hover effect if you want */
}
.pageLayout .aboutPageContent .fa {
  padding: 20px;
  font-size: 30px;
  width: 50px;
  text-align: center;
  text-decoration: none;
}
.pageLayout .aboutPageContent .fa:hover {
  opacity: 0.7;
}
.pageLayout .aboutPageContent .fa-instagram {
  background: #3B5998;
  color: white;
}
.pageLayout .navigationHeader {
  z-index: 100000000;
  position: sticky;
  top: 0;
  list-style-type: none;
  text-align: center;
  background-color: #b7d395;
  border-bottom: solid 1px #ffffff;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.pageLayout .navigationHeader .test {
  height: 50px;
  width: 50px;
  margin-right: auto;
  border-right: solid 1px #ffffff;
}
.pageLayout .navigationHeader .test img {
  height: 50px;
}
.pageLayout .navigationHeader li {
  margin-right: 10px;
  color: #ffffff;
  vertical-align: middle;
  display: inline-block;
}
.pageLayout .navigationHeader li .navigationHeaderLink {
  text-decoration: none;
  list-style: none;
  color: #ffffff;
  display: inline-block;
}
.pageLayout .navigationHeader li p {
  margin: 0px;
}

span.blockspam {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/pages/components/components.scss"],"names":[],"mappings":"AASA;EACE,gBAAA;EACA,yBATiB;EAUjB,8BAAA;EACA,yCAAA,EAAA,mBAAA;AARF;;AAWA;EAEE,YAAA;EACA,OAAA;EACA,eAAA;EACA,MAAA;EACA,WAAA;AATF;AAWE;EACE,WAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;AATJ;AAWI;EACE,mBA/Ba;EAgCb,YAAA;EACA,UAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AATN;AAYE;EACE,iBAAA;EACA,yDAAA;AAVJ;AAYE;EACE,gCAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,qBAAA;AAVJ;AAaI;EACE,YAAA;EACA,yBAzDU;EA0DV,qBAAA;EACA,iBAAA;AAXN;AAcM;EAPF;IAQI,mFAAA;IACA,iBAAA;EAXN;AACF;AAaI;EACE,YAAA;EACA,qBAAA;EACA,iBAAA;AAXN;AAaM;EALF;IAMI,mFAAA;IACA,iBAAA;EAVN;AACF;AAYI;EACE,YAAA;EACA,yBA/EU;EAgFV,qBAAA;AAVN;AAaI;EACE,cApFU;AAyEhB;AAgBE;EACE,iBAAA;AAdJ;AAgBI;EACE,gCAAA;EACA,8BAAA;EACA,kBAAA;AAdN;AAgBM;EACE,cAlGQ;AAoFhB;AAiBI;EACE,2BAAA;EACA,0BAAA;AAfN;AAkBI;EACE,WAAA;EACA,SAAA;EACA,YAAA;EACA,oBAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;AAhBN;AAkBM;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;EACA,wBAAA;AAhBR;AAqBQ;EACE,UAAA;AAnBV;AAuBM;EACE,YAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,2BAAA;AArBR;AA0BI;EACE,WAAA;EACA,SAAA;EACA,YAAA;EACA,oBAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,qBAAA;AAxBN;AA0BM;EACE,UAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;EACA,iCAAA;AAxBR;AA2BM;EACE,aAAA;AAzBR;AA4BM;EACE,aAAA;AA1BR;AA4BM;EACE,aAAA;AA1BR;AAgCQ;EACE,UAAA;AA9BV;AAkCM;EACE,YAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,2BAAA;AAhCR;AAmCI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AAjCN;AAmCI;EACE,cAtMU;EAuMV,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,2BAAA;EACA,eAAA;EACA,YAAA;AAjCN;AAmCM;EATF;IAUI,mFAAA;IACA,2BAAA;IACA,gBAAA;EAhCN;AACF;AAsCM;EACE,cAAA;AApCR;AAwCI;EAKE,aAAA;AA1CN;AA6CI;EACE,aAAA;AA3CN;AAiDM;EACE,cAAA;EACA,YAAA;EACA,yBA/OQ;EAgPR,qBAAA;EACA,kBAAA;EACA,4BAAA;EACA,QAAA;EACA,UAAA;EACA,eAAA;AA/CR;AAoDE;EACE,iBAAA;AAlDJ;AAoDI;EACE,gCAAA;EACA,8BAAA;EACA,kBAAA;AAlDN;AAqDM;EACE,cApQQ;AAiNhB;AAsDI;EACE,2BAAA;EACA,0BAAA;AApDN;AAuDI;EACE,aAAA;AArDN;AAuDI;EACE,aAAA;EACA,uBAAA;EACA,qBAAA;AArDN;AAwDI;EACE,YAAA;EACA,WAAA;AAtDN;AAwDI;EACE,aAAA;EACA,uBAAA;EACA,qBAAA;AAtDN;AAwDI;EACE,YAAA;EACA,yBAhSU;EAiSV,qBAAA;AAtDN;AA0DI;EACE,WAAA;AAxDN;AA4DE;EACE,cA3SY;EA4SZ,WAAA;EACA,kBAAA;EACA,aAAA;AA1DJ;AA4DI;EACE,cAAA;EACA,sBAAA;AA1DN;AA4DM;EACE,WAAA;AA1DR;AA8DI;EACE,qBAAA;EACA,cAAA;EACA,mDAAA;EACA,4BAAA;EACA,wBAAA;EACA,YAAA;EACA,WAAA;AA5DN;AAkEM;EACE,qBAAA;EAEA,mDAAA;EACA,4BAAA;EACA,wBAAA;EACA,YAAA;EACA,WAAA;AAjER;AAuEI;EACE,WAAA;AArEN;AAuEI;EACE,cAAA;EACA,WAAA;EACA,sBAAA;AArEN;AAyEE;EACE,iCAAA;EASA,mCAAA;AA/EJ;AAuEI;EACE,aAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;AArEN;AAyEI;EACE,YAAA;AAvEN;AA0EI;EACE,mBAAA;EACA,YAAA;AAxEN;AA6EE;EAUE,kBAAA;EACA,gBAAA;EACA,MAAA;EACA,qBAAA;EACA,kBAAA;EACA,yBAjYe;EAkYf,gCAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;AApFJ;AAkEI;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,+BAAA;AAhEN;AAiEM;EACE,YAAA;AA/DR;AA4EI;EACE,kBAAA;EACA,cAzYU;EA0YV,sBAAA;EACA,qBAAA;AA1EN;AA2EM;EACE,qBAAA;EACA,gBAAA;EACA,cA/YQ;EAgZR,qBAAA;AAzER;AA4EM;EACE,WAAA;AA1ER;;AAgFA;EACE,aAAA;AA7EF","sourcesContent":["$font-stack: Helvetica, sans-serif;\n$primary-color: #ffffff;\n$background-color: #b7d395;\n$darker-color: #e2f1c7;\n$tertiary-color: #fdf9c3;\n\n$border-color: #ffffff;\n$assetPath :\"/../../images\";\n\nhtml, body {\n  min-height: 100%;\n  background-color: $background-color;\n  font-family: Inter, sans-serif;\n  font-feature-settings: 'liga' 1, 'calt' 1; /* fix for Chrome */\n}\n\n.pageLayout {\n  // used to center main div start\n  height: 100%;\n  left: 0;\n  position: fixed;\n  top: 0;\n  width: 100%;\n\n  .container {\n    height: 90%;\n    width: 80%;\n    left: 50%;\n    position: absolute;\n    top: 50%;\n    z-index: 10;\n\n    .pageBody {\n      background: $background-color;\n      height: 100%;\n      left: -50%;\n      position: absolute;\n      top: -50%;\n      width: 100%;\n      border: solid 1px $border-color;\n      overflow-x: hidden;\n      overflow-y: auto;\n    }\n  }\n  .rowTitle {\n    border-left: none;\n    background-image: url(\"../../images/pinkChekck.jpg\");\n  }\n  .colTitle {\n    border-bottom: 1px solid $border-color;\n    padding-top: 20px;\n    padding-bottom: 20px;\n    text-align: center;\n    text-decoration: none;\n\n\n    .navTitle {\n      color: black;\n      background-color: $primary-color;\n      text-decoration: none;\n      font-size: medium;\n\n\n      @media (max-width: 576px) {\n        /* CSS that should be displayed if width is equal to or less than 800px goes here */\n        font-size: medium;\n      }\n    }\n    .subTitle {\n      color: black;\n      text-decoration: none;\n      font-size: medium;\n\n      @media (max-width: 576px) {\n        /* CSS that should be displayed if width is equal to or less than 800px goes here */\n        font-size: medium;\n      }\n    }\n    .title {\n      color: black;\n      background-color: $primary-color;\n      text-decoration: none;\n    }\n\n    div {\n      color: $primary-color;\n    }\n  }\n\n  //Per Container Classes\n  .productPageContainer {\n    position: inherit;\n\n    .col {\n      border-bottom: 1px solid $border-color;\n      border-left: 1px solid $border-color;\n      text-align: center;\n\n      div {\n        color: $primary-color;\n      }\n    }\n    .row > * {\n      padding-right: 0 !important;\n      padding-left: 0 !important;\n    }\n    // used to center main div end\n    .imageWrapper {\n      width: 100%;\n      height: 0;\n      margin: auto;\n      padding-bottom: 100%;\n      overflow: hidden;\n      position: relative;\n      z-index: 90;\n\n      .mainImage {\n        width: 100%;\n        position: absolute;\n        left: 0;\n        top: 50%;\n        transform: translateY(-50%);\n        z-index: 90;\n        transition: opacity 0.5s;\n      }\n      &:hover,\n      &:active,\n      &:focus  {\n        .mainImage {\n          opacity: 0;\n        }\n      }\n\n      .hoverImage {\n        height: 100%;\n        position: absolute;\n        left: 0;\n        top: 50%;\n        transform: translateY(-50%);\n      }\n    }\n\n    // used to center main div end\n    .NailCommission-imageWrapper {\n      width: 100%;\n      height: 0;\n      margin: auto;\n      padding-bottom: 100%;\n      overflow: hidden;\n      position: relative;\n      z-index: 90;\n      display: flex;\n      justify-content: center;\n      align-content: center;\n\n      .NailCommission-mainImage {\n        width: 80%;\n        position: absolute;\n        left: 0;\n        top: 50%;\n        transform: translateY(-50%);\n        z-index: 90;\n        transition: background-color 0.5s;\n\n      }\n      .NailCommission-Image {\n        padding: 10px;\n\n      }\n      .NailCommissionPage-col {\n        padding: 10px;\n      }\n      .NailCommissionPage-row {\n        border: white;\n      }\n\n      &:hover,\n      &:active,\n      &:focus  {\n        .NailCommission-mainImage {\n          opacity: 0;\n        }\n      }\n\n      .NailCommission-hoverImage {\n        height: 100%;\n        position: absolute;\n        left: 0;\n        top: 50%;\n        transform: translateY(-50%);\n      }\n    }\n    .NailCommission-tileTitleWrapper {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      color: white;\n    }\n    .NailCommission-tileTitle {\n      color: $primary-color;\n      text-decoration: none;\n      font-size: 20rem;\n      position: absolute;\n      transform: translateY(-45%);\n      z-index: 100000;\n      opacity: 50%;\n\n      @media (max-width: 992px) {\n        /* CSS that should be displayed if width is equal to or less than 800px goes here */\n        transform: translateY(-50%);\n        font-size: 100px;\n      }\n    }\n\n    &:hover,\n    &:active,\n    &:focus  {\n      .NailCommission-tileTitle {\n        color: #b7d395 ;\n      }\n    }\n\n    .tileTitleWrapper {\n      //display: block;\n      //position: relative;\n      //text-align: center;\n      //color: white;\n      display: none;\n\n    }\n    .tileTitle {\n      display: none;\n    }\n\n    &:hover,\n    &:active,\n    &:focus  {\n      .tileTitle {\n        display: block;\n        color: black;\n        background-color: $primary-color;\n        text-decoration: none;\n        position: absolute;\n        transform: translateY(-100%);\n        left: 1%;\n        bottom: 1%;\n        z-index: 100000;\n      }\n    }\n  }\n\n  .NailCommissionPageContent {\n    position: inherit;\n\n    .col {\n      border-bottom: 1px solid $border-color;\n      border-left: 1px solid $border-color;\n      text-align: center;\n\n\n      div {\n        color: $primary-color;\n      }\n    }\n    .row > * {\n      padding-right: 0 !important;\n      padding-left: 0 !important;\n    }\n\n    .NailCommissionPage-row {\n      padding: 40px;\n    }\n    .NailCommissionPage-ImageWrapper {\n      display: flex;\n      justify-content: center;\n      align-content: center;\n\n    }\n    .NailCommissionPage-Image {\n      height: auto;\n      width: 40px;\n    }\n    .NailCommissionPage-TextWrapper {\n      display: flex;\n      justify-content: center;\n      align-content: center;\n    }\n    .NailCommissionPage-Text {\n      color: black;\n      background-color: $primary-color;\n      text-decoration: none;\n    }\n  }\n  .homePageContent {\n    img {\n      width: 100%;\n    }\n  }\n\n  .pageFooter {\n    color: $primary-color;\n    width:100%;\n    text-align: center;\n    padding: 10px;\n\n    .pageFooterText {\n      margin: 0 auto;\n      vertical-align: middle;\n\n      p {\n        margin: 0px;\n      }\n    }\n\n    .pageFooterImage {\n      display: inline-block;\n      margin: 0 auto;\n      background: url('../../images/MiffyUnclicked.png');\n      background-repeat: no-repeat;\n      background-size: contain;\n      height: 50px;\n      width: 50px;\n    }\n\n    &:hover,\n    &:active,\n    &:focus {\n      .pageFooterImage {\n        display: inline-block;\n\n        background: url('../../images/MiffyClicked.png');\n        background-repeat: no-repeat;\n        background-size: contain;\n        height: 50px;\n        width: 50px;\n      }\n  }\n}\n\n  .detailPageContent {\n    img {\n      width: 100%;\n    }\n    .email {\n      height:1.1rem;\n      width: auto;\n      vertical-align: bottom;\n    }\n  }\n\n  .aboutPageContent {\n    /* Style all font awesome icons */\n    .fa {\n      padding: 20px;\n      font-size: 30px;\n      width: 50px;\n      text-align: center;\n      text-decoration: none;\n    }\n\n    /* Add a hover effect if you want */\n    .fa:hover {\n      opacity: 0.7;\n    }\n\n    .fa-instagram {\n      background: #3B5998;\n      color: white;\n    }\n\n  }\n\n  .navigationHeader {\n    .test {\n      height: 50px;\n      width: 50px;\n      margin-right: auto;\n      border-right: solid 1px $border-color;\n      img {\n        height: 50px;\n      }\n    }\n    z-index: 100000000;\n    position: sticky;\n    top: 0;\n    list-style-type: none;\n    text-align: center;\n    background-color: $background-color;\n    border-bottom: solid 1px $border-color;\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    li {\n      margin-right: 10px;\n      color: $primary-color;\n      vertical-align: middle;\n      display: inline-block;\n      .navigationHeaderLink {\n        text-decoration: none;\n        list-style: none;\n        color: $primary-color;\n        display: inline-block;\n      }\n\n      p {\n        margin: 0px;\n      }\n    }\n\n  }\n}\nspan.blockspam {\n  display: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
